<template>
  <div class="dropdown-form" v-click-outside="closePopup">
    <div class="buttonn" :class="{'active': active}" @click="handleClick">
      <i :class="icon"></i>
      <div class="text" v-if="active">
        {{ activeTitle }}
      </div>
      <div class="text" v-else>
        {{ inactiveTitle }}
      </div>
    </div>
    <div v-if="popup" class="popup" :class="{'active': popupActive}">
      <b-row v-if="add && !addActive" class="d-flex justify-content-end">
        <i @click="addActive = true" class="cursor-pointer bx bx-plus-circle text-primary mr-3 mt-2 mb-2"></i>
      </b-row>
      <b-row v-if="add && addActive" class="d-flex justify-content-end cursor-pointer">
        <i @click="addActive = false" class="cursor-pointer bx bx-x-circle text-primary mr-3 mt-2 mb-2"></i>
      </b-row>
      <div class="content-slot" :class="{'active': !addActive}">
        <slot name="popup"></slot>
      </div>
      <div class="form-slot" :class="{'active': addActive}">
        <slot name="add"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";

export default {
  name: "dropdown",

  props: {
    activeTitle: {
      type: String,
      required: true
    },
    inactiveTitle: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    },
    popup: {
      type: Boolean,
      default: true
    },
    add: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      popupActive: false,
      addActive: false,
    }
  },

  methods: {
    handleClick() {
      this.popupActive = !this.popupActive;
      this.$emit("click")
    },

    closePopup() {
      this.popupActive = false;
    },

    manageAdd(){
      this.addActive = !this.addActive
    }
  },

  directives: {
    ClickOutside
  }

}
</script>

<style scoped>

</style>